import React, { useState, useEffect } from 'react';

import { useGetOpportunityInfoGather } from '@/api/opportunities/useGetOpportunityInfoGather';
import { toast } from 'react-toastify';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

const OpportunityInfoTab = ({funnel, oppID, oppData}) => {
    const [isEditing, setIsEditing] = useState(false);
    const [showReassignConfirmationModal, setShowReassignConfirmationModal] = useState(false);
    const [leadJourney, setLeadJourney] = useState({});
    const [userId, setUserId] = useState(null);
    const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
    const lead_id = oppData?.lead_id;
    // const [oppDetails, setOppDetails] = useState(null);

    const relationshipStrengthMap = {
        1: { label: "Cold", icon: <img src="/icons/cold.svg" className='size-8 -mt-1'/> },
        2: { label: "Warm", icon: <img src="/icons/warm.svg" className='size-8 -mt-1'/> },
        3: { label: "Hot", icon: <img src="/icons/hot.svg" className='size-8 -mt-1'/> },
    };
    const relationshipStrength = leadJourney.interest_level;
    const { label, icon } = relationshipStrengthMap[relationshipStrength] || { label: "", icon: "" };
    
    // if (funnel==='Financing'){
    //     const {oppDetails, refetch} = getOpportunityInfoGather({oppID, funnel});
    //     console.table("Opportunity Details:", oppDetails);


    //     const formatCurrency = (value) => {
    //         if (value === null || value === undefined || isNaN(parseFloat(value))) {
    //             return "0.00";
    //         }
    //         return parseFloat(value).toLocaleString('en-US', {
    //             minimumFractionDigits: 2,
    //             maximumFractionDigits: 2
    //         });
    //     }
    //     const [financingformData, setFinancingFormData] = useState({
    //         type: 'Invoice',
    //         type_other: '',
    //         partner: 'Capbay',
    //         partner_other: '',
    //         requested_amt: 0,
    //         products_id: oppDetails?.products_id,
    //         status: 3,
    //         updated_by: 19, // Assuming 19 is the user ID of the logged-in user
    //     });
    // }
    console.log("Funnel Type:", funnel)
    
    // Move these to the top level of your component
    const formatCurrency = (value) => {
        if (value === null || value === undefined || isNaN(parseFloat(value))) {
            return "0.00";
        }
        return parseFloat(value).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    // Initialize financingFormData at the top level
    const [financingformData, setFinancingFormData] = useState({
        type: 'Invoice',
        type_other: '',
        partner: 'Capbay',
        partner_other: '',
        requested_amt: 0,
        products_id: null,
        status: 3,
        updated_by: 19,
    });

    const {oppDetails, refetch} = useGetOpportunityInfoGather({oppID, funnel})
    // Conditionally fetch oppDetails only for Financing funnel
    // useEffect(() => {
    //     if (funnel === 'Financing') {
    //         const { fetchedOppDetails, refetch } = getOpportunityInfoGather({ oppID, funnel });
            
    //         if (oppDetails) {
    //             setOppDetails(oppDetails);
    //         }
    //     } else {
    //         setOppDetails(null); // Clear for other funnels
    //     }
    // }, [funnel, oppID]);

    // Main useEffect that handles all funnel types
    useEffect(() => {
        if (!router.isReady || !oppData?.lead_id) return;

        const storedUserId = Number(localStorage.getItem("userId"));
        setUserId(storedUserId);

        if (oppData.funnel === 'Referral') {
            fetch(`${import.meta.env.VITE_BASE_URL}/opp_referral_details?lead_id=${oppData.referred_lead_id}`)
                .then((res) => res.json())
                .then((data) => {
                    setLeadJourney(data);
                    setReferralFormData(data);
                })
                .catch((error) => console.error('Error fetching details:', error));

        } else if (oppData.funnel === 'Financing') {
            // This will run when oppDetails changes
            // if (oppDetails) {
            //     setFinancingFormData(prev => ({
            //         ...prev,
            //         type: oppDetails.type || 'Invoice',
            //         type_other: oppDetails.type_other || '',
            //         partner: oppDetails.partner || 'Capbay',
            //         partner_other: oppDetails.partner_other || '',
            //         requested_amt: oppDetails.requested_amt || 0,
            //         products_id: oppDetails?.products_id,
            //     }));
            // }
            // if (funnel === 'Financing') {
                // const {oppDetails, refetch} = getOpportunityInfoGather({oppID, funnel})
                        
                //         if (oppDetails) {
                //             setOppDetails(oppDetails);

                //             if (oppDetails) {
                //                     setFinancingFormData(prev => ({
                //                         ...prev,
                //                         type: oppDetails.type || 'Invoice',
                //                         type_other: oppDetails.type_other || '',
                //                         partner: oppDetails.partner || 'Capbay',
                //                         partner_other: oppDetails.partner_other || '',
                //                         requested_amt: oppDetails.requested_amt || 0,
                //                         products_id: oppDetails?.products_id,
                //                     }));
                //                 }
                //         }

        } else {
            fetch(`${import.meta.env.VITE_BASE_URL}/lead_journey_tbl?lead_id=${oppData.lead_id}`)
                .then((res) => res.json())
                .then((data) => {
                    setLeadJourney(data);
                    setReferralFormData(data);
                })
                .catch((error) => console.error('Error fetching details:', error));
        }

    }, [router.isReady, oppData?.lead_id, oppDetails]);
    

    const [referralformData, setReferralFormData] = useState({
        race_of_pic_others: '',
        user_id: userId
    });

    // useEffect(() => {

    //     if (!router.isReady || !oppData?.lead_id) return;

    //     const storedUserId = Number(localStorage.getItem("userId"));
    //     setUserId(storedUserId);
    //     console.log("UserID:", userId)

    //     if(oppData.funnel==='Referral'){
    //         fetch(`${import.meta.env.VITE_BASE_URL}/opp_referral_details?lead_id=${oppData.referred_lead_id}`)
    //         .then((res) => res.json())
    //         .then((data) => {
    //             console.log('Fetched data:', data); 
    //             setLeadJourney(data);
    //             setReferralFormData(data);
    //         })
    //         .catch((error) => console.error('Error fetching details:', error));

    //     }else if(oppData.funnel==='Financing'){

    //         if (oppDetails) {
    //             setFinancingFormData({
    //                 type: oppDetails.type || 'Invoice',
    //                 type_other: oppDetails.type_other || '',
    //                 partner: oppDetails.partner || 'Capbay',
    //                 partner_other: oppDetails.partner_other || '',
    //                 requested_amt: oppDetails.requested_amt || 0,
    //                 products_id: oppDetails?.products_id,
    //                 status: 3,
    //                 updated_by: 19, // Assuming 19 is the user ID of the logged-in user
    //             });
    //         }

    //     }else{
    //         fetch(`${import.meta.env.VITE_BASE_URL}/lead_journey_tbl?lead_id=${oppData.lead_id}`)
    //         .then((res) => res.json())
    //         .then((data) => {
    //             setLeadJourney(data);
    //             setReferralFormData(data);
    //         })
    //         .catch((error) => console.error('Error fetching details:', error));
    //     }
        
    // }, [oppDetails], router.isReady, oppData?.lead_id);
    

    const handleCancel = () => {
        setFinancingFormData({
            type: 'Invoice',
            type_other: '',
            partner: 'Capbay',
            partner_other: '',
            requested_amt: 0,
            products_id: oppDetails?.products_id,
            status: 3,
            updated_by: 19, // Assuming 19 is the user ID of the logged-in user
        });
        setIsEditing(false); // Exit edit mode
        setReferralFormData(leadJourney);
    };
    
    const handleConfirmationCancel = () => {
        setShowReassignConfirmationModal(false); // Close confirmation modal
        setIsEditing(false); // Exit edit mode
    }

    const handleSubmit = () => {
        setShowReassignConfirmationModal(true);
    };
    const handleFinancingConfirmationSubmit = async () => {
        try {
            const response = await fetch(`${import.meta.env.VITE_BASE_URL}/opp_insert_detail/${funnel}?opp_id=${oppID}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    oppID,
                    ...financingformData
                })
            });

            if (response.ok) {
                setIsEditing(false);
                refetch(); // Refresh the data after confirmation
                toast.success('Opportunity updated successfully!');
                setShowReassignConfirmationModal(false); // Close confirmation modal
            } else {
                toast.error('Failed to update opportunity');
            }
        } catch (error) {
            console.error('Error updating opportunity:', error);
            toast.error('Error updating opportunity');
        };
    };
    const handleEditClick = () => {
        setIsEditing(!isEditing);
    };
    const handleChange = e => {
        const { name, value } = e.target;
        setFinancingFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
        setReferralFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const handleReassignConfirmation = () => {

        if(oppData.funnel==='Referral'){

            console.log('Submitting data:', formData);
            fetch(`${import.meta.env.VITE_BASE_URL}/update_lead_journey_ref?lead_id=${oppData.referred_lead_id}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            })
                .then((res) => res.json())
                .then((data) => {
                    console.log('Success:', data);
                    setIsEditing(false);
                    fetch(`${import.meta.env.VITE_BASE_URL}/opp_referral_details?lead_id=${oppData.referred_lead_id}`)
                        .then((res) => res.json())
                        .then((data) => {
                            setLeadJourney(data);
                            setReferralFormData(data);
                        })
                        .catch((error) => console.error('Error fetching details:', error));
                })
                .catch((error) => {
                    console.error('Error:', error);
                });

        }else{
            fetch(`${import.meta.env.VITE_BASE_URL}/update_lead_journey?lead_id=${lead_id}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            })
                .then((res) => res.json())
                .then((data) => {
                    console.log('Success:', data);
                    setIsEditing(false);
                    fetch(`${import.meta.env.VITE_BASE_URL}/lead_journey_tbl?lead_id=${lead_id}`)
                        .then((res) => res.json())
                        .then((data) => {
                            setLeadJourney(data);
                            setReferralFormData(data);
                        })
                        .catch((error) => console.error('Error fetching details:', error));
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }


        

        setShowReassignConfirmationModal(false);
    }

    const handleRelationshipStrengthChange = (e) => {
        const value = parseInt(e.target.value, 10);
        setReferralFormData(prevState => ({
            ...prevState,
            interest_level: value
        }));
    };

    const handleConfirmation = () => {
        if (oppData.funnel === "Financing") {
            handleFinancingConfirmationSubmit();
        } else if (oppData.funnel === "Referral") {
            handleReassignConfirmation();
        } else {
            setShowReassignConfirmationModal(false);
        }
    };
    return(
        <>
        <div className="w-full bg-white p-7 rounded-3xl shadow-lg">
            
            { (funnel === 'Financing') && (
                <>
                <div className="flex justify-between items-start">
                <div className="flex items-center">
                    <p className="font-bold text-2xl text-[#1E293B]">Information Gathering</p>
                </div>
                <div className="flex space-x-2">
                    {isEditing && (
                        <button
                            className="group bg-white text-black p-3 rounded-full border-[1px] border-black hover:bg-gray-200 transition flex items-center justify-center w-12 h-12"
                            onClick={handleCancel}
                            aria-label="Cancel Editing"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="1.5"
                                stroke="currentColor"
                                className="size-6"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M6 18 18 6M6 6l12 12"
                                />
                            </svg>
                        </button>
                    )}
                    <button
                        className="group bg-white text-black p-3 rounded-full border-[1px] border-black hover:bg-yellow-300 transition flex items-center justify-center w-12 h-12"
                        onClick={isEditing ? handleSubmit : handleEditClick}
                        aria-label={isEditing ? 'Submit' : 'Edit Lead'}
                        >
                        {isEditing ? (
                            <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor"
                            className="size-6"
                            >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="m4.5 12.75 6 6 9-13.5"
                            />
                            </svg>
                        ) : (
                            <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor"
                            className="size-6"
                            >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
                            />
                            </svg>
                        )}
                    </button>
                </div>
            </div>
                <div className="flex items-center mt-5">
                    <div className="border-b border-gray-200 pb-2 w-full flex">
                        <span className="w-1/5 font-bold text-[#475569]">Financing Type</span>
                        {isEditing ? (
                            <select 
                                name='type'
                                value={financingformData.type}
                                onChange={handleChange}
                                className='flex-1'
                            >
                                <option value="Invoice">Invoice</option>
                                <option value="Supply Chain">Supply Chain</option>
                                <option value="Working Capital">Working Capital</option>
                                <option value="Others">Others</option>
                            </select>
                        ) : (
                            <>
                            <div className="flex-1 text-[#475569]">
                                <span>{oppDetails?.type || ''}</span>
                            </div>
                            <button
                                onClick={() => {
                                    navigator.clipboard.writeText(`${oppDetails?.type || ''}`);
                                    toast.success('Copied to clipboard!');
                                } }
                                className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                            >
                                <img src="/icons/content_copy.svg" className='size-6' />
                            </button>
                            </>
                        )}
                    </div>
                </div>
                {financingformData.type === 'Others' && (
                    <div className="flex items-center mt-5">
                        <div className="border-b border-gray-200 pb-2 w-full flex">
                            <span className="w-1/5 font-bold text-[#475569]">Financing Type (Others)</span>
                            {isEditing ? (
                                <input 
                                    type="text"
                                    name='type_other'
                                    value={financingformData.type_other}
                                    onChange={handleChange}
                                    placeholder="Enter custom financing type"
                                    className='flex-1'
                                />
                            ) : (
                                <>
                                <div className="flex-1 text-[#475569]">
                                    <span>{oppDetails?.type_other || ''}</span>
                                </div>
                                <button
                                    onClick={() => {
                                        navigator.clipboard.writeText(`${oppDetails?.type_other || ''}`);
                                        toast.success('Copied to clipboard!');
                                    } }
                                    className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                >
                                    <img src="/icons/content_copy.svg" className='size-6' />
                                </button>
                                </>
                            )}
                        </div>
                    </div>
                )}
                <div className="flex items-center mt-5">
                    <div className="border-b border-gray-200 pb-2 w-full flex">
                        <span className="w-1/5 font-bold text-[#475569]">Financing Partner</span>
                        {isEditing ? (
                            <select 
                                name='partner'
                                value={financingformData.partner}
                                onChange={handleChange}
                                className='flex-1'
                            >
                                <option value="Capbay">Capbay</option>
                                <option value="Boost">Boost</option>
                                <option value="Funding Society">Funding Society</option>
                                <option value="Microleap">Microleap</option>
                                <option value="Others">Others</option>
                            </select> 
                        ):(
                            <>
                            <div className="flex-1 text-[#475569]">
                                <span>{oppDetails?.partner || ''}</span>
                            </div>
                            <button
                                onClick={() => {
                                    navigator.clipboard.writeText(`${oppDetails?.partner || ''}`);
                                    toast.success('Copied to clipboard!');
                                } }
                                className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                            >
                                <img src="/icons/content_copy.svg" className='size-6' />
                            </button>
                            </>
                        )}
                    </div>
                </div>
                {financingformData.partner === 'Others' && (
                    <div className="flex items-center mt-5">
                        <div className="border-b border-gray-200 pb-2 w-full flex">
                            <span className="w-1/5 font-bold text-[#475569]">Financing Partner (Others)</span>
                            {isEditing ? (
                                <input 
                                    type="text"
                                    name='partner_other'
                                    value={financingformData.partner_other}
                                    onChange={handleChange}
                                    placeholder="Enter custom financing type"
                                    className='flex-1'
                                />
                            ) : (
                                <>
                                <div className="flex-1 text-[#475569]">
                                    <span>{oppDetails?.partner_other || ''}</span>
                                </div>
                                <button
                                    onClick={() => {
                                        navigator.clipboard.writeText(`${oppDetails?.partner_other || ''}`);
                                        toast.success('Copied to clipboard!');
                                    } }
                                    className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                >
                                    <img src="/icons/content_copy.svg" className='size-6' />
                                </button>
                                </>
                            )}
                        </div>
                    </div>
                )}
                <div className="flex items-center mt-5">
                    <div className="border-b border-gray-200 pb-2 w-full flex">
                        <span className="w-1/5 font-bold text-[#475569]">Requested Amount</span>
                        { isEditing ? (
                            <div className="flex-1 flex items-center">
                                <span className="text-[#475569] mr-2">MYR</span>
                                <input 
                                    type="number"
                                    name='requested_amt'
                                    value={financingformData.requested_amt}
                                    onChange={handleChange}
                                    className='flex-1'
                                />
                            </div>
                        ):(
                            <>
                            <div className="flex-1 text-[#475569]">
                                <span>MYR {formatCurrency(oppDetails?.requested_amt || 0) }</span>
                            </div>
                            <button
                                onClick={() => {
                                    navigator.clipboard.writeText(`MYR ${formatCurrency(oppDetails?.requested_amt || 0)}`);
                                    toast.success('Copied to clipboard!');
                                } }
                                className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                            >
                                <img src="/icons/content_copy.svg" className='size-6' />
                            </button>
                            </>
                        )}
                    </div>
                </div>
                </>  
            )}

            {oppData.funnel === 'Referral' && (
            <div className='w-full bg-white p-7 rounded-3xl'>
                {/* Lead Ownership Section */}
                <div className="flex justify-between items-start">
                <div className="flex items-center">
                    <p className="font-bold text-2xl">
                    {oppData.funnel === 'Referral' ? 'Referral Company' : 'Lead Ownership'}
                    </p>
                </div>
                <div className="flex space-x-2">
                    {isEditing && (
                    <button
                        className="group bg-white text-black p-3 rounded-full border-[1px] border-black hover:bg-gray-200 transition flex items-center justify-center w-12 h-12"
                        onClick={handleCancel}
                        aria-label="Cancel Editing"
                    >
                        <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="size-6"
                        >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6 18 18 6M6 6l12 12"
                        />
                        </svg>
                    </button>
                    )}

                    <button
                    className="group bg-white text-black p-3 rounded-full border-[1px] border-black hover:bg-yellow-300 transition flex items-center justify-center w-12 h-12"
                    onClick={isEditing ? handleSubmit : handleEditClick}
                    aria-label={isEditing ? 'Submit' : 'Edit Lead'}
                    >
                    {isEditing ? (
                        <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="size-6"
                        >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="m4.5 12.75 6 6 9-13.5"
                        />
                        </svg>
                    ) : (
                        <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="size-6"
                        >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
                        />
                        </svg>
                    )}
                    </button>
                </div>
                </div>

                {/* Grid Container for All Rows */}
                <div className="grid grid-cols-2 gap-x-5 ml-5">
                {/* Company Name and Hunter */}
                <div className="flex items-start mt-5">
                    <p className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/3"><b>Company Name</b></span>
                    {isEditing ? (
                        <input
                        type="text"
                        name="company_name"
                        value={referralformData.company_name || ''}
                        onChange={handleChange}
                        className="flex-1"
                        />
                    ) : (
                        <div className="flex-1 flex items-center">
                        <span>{leadJourney.company_name}</span>
                        
                        </div>
                    )}
                    <button
                        onClick={() => {
                        navigator.clipboard.writeText(leadJourney.company_name);
                        toast.success('Copied to clipboard!');
                        }}
                        className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        <img src="/icons/content_copy.svg" className='size-6'/>
                    </button>
                    </p>
                </div>
                {oppData.funnel !== 'Referral' && (
                <div className="flex items-start mt-5">
                    <p className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/3"><b>Hunter</b></span>
                    {isEditing ? (
                        <input
                        type="text"
                        name="hunter_name"
                        value={referralformData.hunter_name || ''}
                        onChange={handleChange}
                        className="flex-1 bg-gray-100 cursor-not-allowed mr-6"
                        disabled
                        readOnly
                        />
                    ) : (
                        <span className="flex-1">{leadJourney.hunter_name}</span>
                    )}
                    {leadJourney.hunter_id === userId &&
                    ![4, 5, 6].includes(leadJourney.status) ? (
                        <button
                        onClick={handleReassignClick}
                        className="text-black underline hover:text-blue-800 focus:outline-none mr-2 font-bold text-sm"
                        >
                        Reassign
                        </button>
                    ) : null}
                    </p>
                </div>
                )}

                {/* Contact Method and Lead Source */}
                <div className="flex items-start mt-5">
                    <p className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/3"><b>Contact Method</b></span>
                    {isEditing ? (
                        <input
                        type="text"
                        name="contact_method"
                        value={referralformData.contact_method || ''}
                        onChange={handleChange}
                        className="flex-1"
                        />
                    ) : (
                        <span className="flex-1">{leadJourney.contact_method}</span>
                    )}
                    <button
                        onClick={() => {
                        navigator.clipboard.writeText(leadJourney.contact_method);
                        toast.success('Copied to clipboard!');
                        }}
                        className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        <img src="/icons/content_copy.svg" className='size-6'/>
                    </button>
                    </p>
                </div>

                {oppData.funnel !== 'Referral' && (
                <div className="flex items-start mt-5">
                    <p className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/3"><b>Lead Source</b></span>
                    {isEditing ? (
                        <input
                        type="text"
                        name="lead_source"
                        value={referralformData.lead_source || ''}
                        onChange={handleChange}
                        className="flex-1"
                        />
                    ) : (
                        <span className="flex-1">{leadJourney.lead_source}</span>
                    )}
                    </p>
                </div>
                )}

                <div className="flex items-center mt-5 mb-2">
                    <p className="font-bold text-2xl -ml-5 w-full">
                    {oppData.funnel === 'Referral' ? 'Referral Details' : 'Lead Ownership'}
                    </p>
                </div>
                <br></br>
                
                
                {/* Name and Email */}
                <div className="flex items-start mt-5">
                    <p className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/4"><b>Name</b></span>
                    {isEditing ? (
                        <input
                        type="text"
                        name="name"
                        value={referralformData.name || ''}
                        onChange={handleChange}
                        className="flex-1"
                        />
                    ) : (
                        <div className="flex-1 flex items-center">
                        <span>{leadJourney.name}</span>
                        
                        </div>
                    )}
                    <button
                        onClick={() => {
                        navigator.clipboard.writeText(leadJourney.name);
                        toast.success('Copied to clipboard!');
                        }}
                        className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        <img src="/icons/content_copy.svg" className='size-6'/>
                    </button>
                    </p>
                </div>
                <div className="flex items-start mt-5">
                    <p className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/6"><b>Email</b></span>
                    {isEditing ? (
                        <input
                        type="email"
                        name="email"
                        value={referralformData.email || ''}
                        onChange={handleChange}
                        className="flex-1"
                        />
                    ) : (
                        <div className="flex-1 flex items-center">
                        <span>{leadJourney.email}</span>
                        
                        </div>
                    )}
                    <button
                        onClick={() => {
                        navigator.clipboard.writeText(leadJourney.email);
                        toast.success('Copied to clipboard!');
                        }}
                        className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        <img src="/icons/content_copy.svg" className='size-6'/>
                    </button>
                    </p>
                </div>

                {/* Mobile (Personal) and Phone (Office) */}
                <div className="flex items-start mt-5">
                    <p className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/4"><b>Mobile (Personal)</b></span>
                    {isEditing ? (
                        <input
                        type="tel"
                        name="mobile_no"
                        value={referralformData.mobile_no || ''}
                        onChange={handleChange}
                        className="flex-1"
                        />
                    ) : (
                        <div className="flex-1 flex items-center">
                        <span>{leadJourney.mobile_no}</span>
                        
                        </div>
                    )}
                    <button
                        onClick={() => {
                        navigator.clipboard.writeText(leadJourney.mobile_no);
                        toast.success('Copied to clipboard!');
                        }}
                        className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        <img src="/icons/content_copy.svg" className='size-6'/>
                    </button>
                    </p>
                </div>
                <div className="flex items-start mt-5">
                    <p className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/6"><b>Phone (Office)</b></span>
                    {isEditing ? (
                        <input
                        type="tel"
                        name="office_no"
                        value={referralformData.office_no || ''}
                        onChange={handleChange}
                        className="flex-1"
                        />
                    ) : (
                        <div className="flex-1 flex items-center">
                        <span>{leadJourney.office_no}</span>
                        
                        </div>
                    )}
                    <button
                        onClick={() => {
                        navigator.clipboard.writeText(leadJourney.office_no);
                        toast.success('Copied to clipboard!');
                        }}
                        className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        <img src="/icons/content_copy.svg" className='size-6'/>
                    </button>
                    </p>
                </div>

                {/* Designation */}
                <div className=" flex items-start mt-5">
                    <p className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/4"><b>Designation</b></span>
                    {isEditing ? (
                        <input
                        type="text"
                        name="designation"
                        value={referralformData.designation || ''}
                        onChange={handleChange}
                        className="flex-1 -ml-1"
                        />
                    ) : (
                        <span className="flex-1 -ml-1">{leadJourney.designation}</span>
                    )}
                    <button
                        onClick={() => {
                        navigator.clipboard.writeText(leadJourney.designation);
                        toast.success('Copied to clipboard!');
                        }}
                        className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        <img src="/icons/content_copy.svg" className='size-6'/>
                    </button>
                    </p>
                </div>

                {/* Language(s) */}
                <div className=" flex items-start mt-5">
                    <p className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/6"><b>Language(s)</b></span>
                    {isEditing ? (
                        <input
                        type="text"
                        name="language"
                        value={referralformData.language || ''}
                        onChange={handleChange}
                        className="flex-1 -ml-1"
                        />
                    ) : (
                        <span className="flex-1 -ml-1">{leadJourney.language}</span>
                    )}
                    <button
                        onClick={() => {
                        navigator.clipboard.writeText(leadJourney.language);
                        toast.success('Copied to clipboard!');
                        }}
                        className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        <img src="/icons/content_copy.svg" className='size-6'/>
                    </button>
                    </p>
                </div>

                {/* Nature of Business and Industry */}
                <div className="flex items-start mt-5">
                    <p className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/4"><b>Nature of Business</b></span>
                    {isEditing ? (
                        <input
                        type="text"
                        name="nature_of_business"
                        value={referralformData.nature_of_business || ''}
                        onChange={handleChange}
                        className="flex-1"
                        />
                    ) : (
                        <span className="flex-1">{leadJourney.nature_of_business}</span>
                    )}
                    <button
                        onClick={() => {
                        navigator.clipboard.writeText(leadJourney.nature_of_business);
                        toast.success('Copied to clipboard!');
                        }}
                        className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        <img src="/icons/content_copy.svg" className='size-6'/>
                    </button>
                    </p>
                </div>
                <div className="flex items-start mt-5">
                    <p className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/6"><b>Industry</b></span>
                    {isEditing ? (
                        <input
                        type="text"
                        name="industry"
                        value={referralformData.industry || ''}
                        onChange={handleChange}
                        className="flex-1"
                        />
                    ) : (
                        <span className="flex-1">{leadJourney.industry}</span>
                    )}
                    <button
                        onClick={() => {
                        navigator.clipboard.writeText(leadJourney.industry);
                        toast.success('Copied to clipboard!');
                        }}
                        className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        <img src="/icons/content_copy.svg" className='size-6'/>
                    </button>
                    </p>
                </div>

                {/* Relationship Strength */}
                <div className="flex items-start mt-5">
                    <p className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/4"><b>Relationship Strength</b></span>
                    {isEditing ? (
                        <select
                        name="interest_level"
                        value={referralformData.interest_level || ''}
                        onChange={handleRelationshipStrengthChange}
                        className="flex-1 -ml-1"
                        >
                        <option value={1}>Cold</option>
                        <option value={2}>Warm</option>
                        <option value={3}>Hot</option>
                        </select>
                    ) : (
                        <span className="flex-1 -ml-1 inline-flex items-center">
                        {icon} <span className="ml-1">{label}</span>
                        </span>
                    )}
                    </p>
                </div>

                {/* Street */}
                <div className="flex items-start mt-5">
                    <p className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/6"><b>Street</b></span>
                    {isEditing ? (
                        <input
                        type="text"
                        name="street"
                        value={referralformData.street || ''}
                        onChange={handleChange}
                        className="flex-1 -ml-1"
                        />
                    ) : (
                        <div className="flex-1 -ml-1 flex items-center">
                        <span>{leadJourney.street}</span>
                        </div>
                    )}
                    <button
                        onClick={() => {
                        navigator.clipboard.writeText(leadJourney.street);
                        toast.success('Copied to clipboard!');
                        }}
                        className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        <img src="/icons/content_copy.svg" className='size-6'/>
                    </button>
                    </p>
                </div>

                {/* City */}
                <div className="flex items-start mt-5">
                    <p className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/4"><b>City</b></span>
                    {isEditing ? (
                        <input
                        type="text"
                        name="city"
                        value={referralformData.city || ''}
                        onChange={handleChange}
                        className="flex-1 -ml-1"
                        />
                    ) : (
                        <div className="flex-1 -ml-1 flex items-center">
                        <span>{leadJourney.city}</span>
                        
                        </div>
                    )}
                    <button
                        onClick={() => {
                        navigator.clipboard.writeText(leadJourney.city);
                        toast.success('Copied to clipboard!');
                        }}
                        className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        <img src="/icons/content_copy.svg" className='size-6'/>
                    </button>
                    </p>
                </div>

                {/* Post Code */}
                <div className="flex items-start mt-5">
                    <p className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/6"><b>Post Code</b></span>
                    {isEditing ? (
                        <input
                        type="text"
                        name="postal_code"
                        value={referralformData.postal_code || ''}
                        onChange={handleChange}
                        className="flex-1 -ml-1"
                        />
                    ) : (
                        <div className="flex-1 -ml-1 flex items-center">
                        <span>{leadJourney.postal_code}</span>
                        
                        </div>
                    )}
                    <button
                        onClick={() => {
                        navigator.clipboard.writeText(leadJourney.postal_code);
                        toast.success('Copied to clipboard!');
                        }}
                        className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        <img src="/icons/content_copy.svg" className='size-6'/>
                    </button>
                    </p>
                </div>

                {/* State */}
                <div className="flex items-start mt-5">
                    <p className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/4"><b>State</b></span>
                    {isEditing ? (
                        <input
                        type="text"
                        name="state"
                        value={referralformData.state || ''}
                        onChange={handleChange}
                        className="flex-1 -ml-1"
                        />
                    ) : (
                        <div className="flex-1 -ml-1 flex">
                        <span>{leadJourney.state}</span>
                        
                        </div>
                    )}
                    <button
                        onClick={() => {
                        navigator.clipboard.writeText(leadJourney.state);
                        toast.success('Copied to clipboard!');
                        }}
                        className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 items-end"
                    >
                        <img src="/icons/content_copy.svg" className='size-6'/>
                    </button>
                    </p>
                </div>

                {/* Race of PIC */}
                <div className="flex items-start mt-5">
                    <p className='border-b border-gray-200 pb-2 w-full flex items-center'>
                    <span className="w-1/6"><b>Race of PIC</b></span>
                    {isEditing ? (
                        <select
                        name="race_of_pic"
                        value={referralformData.race_of_pic || ''}
                        onChange={handleChange}
                        className="flex-1"
                        >
                        <option value="Malay">Malay</option>
                        <option value="Chinese">Chinese</option>
                        <option value="Indian">Indian</option>
                        <option value="Others">Others</option>
                        </select>
                    ) : (
                        <>
                        <span className="flex-1">{leadJourney.race_of_pic}</span>
                        {leadJourney.race_of_pic !== 'Others' && (
                            <button
                            onClick={() => {
                                navigator.clipboard.writeText(leadJourney.race_of_pic);
                                toast.success('Copied to clipboard!');
                            }}
                            className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                            >
                            <img src="/icons/content_copy.svg" className='size-6'/>
                            </button>
                        )}
                        </>
                    )}
                    </p>
                </div>

                {/* Conditionally render the "If Others, Specify" field */}
                {referralformData.race_of_pic === 'Others' && (
                    <div className="flex items-start mt-5">
                    <p className='border-b border-gray-200 pb-2 w-full flex items-center'>
                        <span className="w-1/3"><b>If Others, Specify</b></span>
                        {isEditing ? (
                        <input
                            type="text"
                            name="race_of_pic_others"
                            value={referralformData.race_of_pic_others || ''}
                            onChange={handleChange}
                            className="flex-1"
                        />
                        ) : (
                        <>
                            <span className="flex-1">{leadJourney.race_of_pic_others}</span>
                            <button
                            onClick={() => {
                                navigator.clipboard.writeText(leadJourney.race_of_pic_others);
                                toast.success('Copied to clipboard!');
                            }}
                            className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                            >
                            <img src="/icons/content_copy.svg" className='size-6'/>
                            </button>
                        </>
                        )}
                    </p>
                    </div>
                )}

                {/* Referral Details Section */}
                {(oppData.funnel === 'Referral') && (
                    <>
                    <div className="col-span-2 flex items-center mt-5">
                        <p className="font-bold text-2xl -ml-5 w-full">Referrer Bank Details</p>
                    </div>
                    
                    <div className="flex items-start mt-5">
                        <p className='border-b border-gray-200 pb-2 w-full flex'>
                        <span className="w-1/3"><b>Bank Account Name</b></span>
                        {isEditing ? (
                            <input
                            type="text"
                            name="bank_acc_name"
                            value={referralformData.bank_acc_name || ''}
                            onChange={handleChange}
                            className="flex-1"
                            />
                        ) : (
                            <span className="flex-1">{leadJourney.bank_acc_name}</span>
                        )}
                        </p>
                    </div>
                    
                    <div className="flex items-start mt-5">
                        <p className='border-b border-gray-200 pb-2 w-full flex'>
                        <span className="w-1/3"><b>Bank Name</b></span>
                        {isEditing ? (
                            <input
                            type="text"
                            name="bank_name"
                            value={referralformData.bank_name || ''}
                            onChange={handleChange}
                            className="flex-1"
                            />
                        ) : (
                            <span className="flex-1">{leadJourney.bank_name}</span>
                        )}
                        </p>
                    </div>
                    
                    <div className="flex items-start mt-5">
                        <p className='border-b border-gray-200 pb-2 w-full flex'>
                        <span className="w-1/3"><b>Bank Account No</b></span>
                        {isEditing ? (
                            <input
                            type="text"
                            name="bank_acc_no"
                            value={referralformData.bank_acc_no || ''}
                            onChange={handleChange}
                            className="flex-1"
                            />
                        ) : (
                            <span className="flex-1">{leadJourney.bank_acc_no}</span>
                        )}
                        </p>
                    </div>
                    </>
                )}
                </div>
            </div>
            )}
        </div>
        {/* Confirmation Modal */}
        {showReassignConfirmationModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center text-center">
                    
                <div className="bg-white p-6 rounded-lg w-1/4">
                    {/* Center the icon using Flexbox */}
                    <div className="flex justify-center mb-2 pt-6">
                        <img src="/icons/edit.svg" className='size-11' />
                    </div>
    
                    <h1 className="text-2xl font-bold mb-3">Save & Update Info Gathering</h1>
                    <p>Info Gathering details will be updated. Please ensure new details are correct.</p>
                    <div className="mt-6 mb-6">
                        <button
                            className="text-black underline hover:text-gray-600 focus:outline-none"
                            onClick={() => handleConfirmationCancel}
                        >
                            <b>No, Don't Update</b>
                        </button>
                        
                    </div>
                    <button
                            className="bg-yellow-300 text-black py-4 w-full rounded-3xl hover:bg-yellow-400"
                            // onClick={handleReassignConfirmation}
                            onClick={handleConfirmation}
                        >
                            <b>Save & Update</b>
                        </button>
                </div>
            </div>
            )}
            
        </>
    )
}
export default OpportunityInfoTab;